import React from 'react';
import Page from '@atlaskit/page';
import { BreadcrumbManager, ProjectBreadcrumb } from '@atlassian/jira-breadcrumbs/src';
import Spinner from '@atlassian/jira-common-components-spinner';
import { ff } from '@atlassian/jira-feature-flagging';
import { JsdGettingStartedPanelShouldRender } from '@atlassian/jira-servicedesk-getting-started-panel/src/async';
import { CreateCategoryModal } from '@atlassian/jira-servicedesk-knowledge-common';
import {
	PageStyle,
	ServiceDeskAppBase,
	ServiceDeskDocumentTitle,
	usePageContext,
} from '@atlassian/jira-servicedesk-spa-commons';
import type { Props } from './types';

export const KnowledgeHubAppBase = (props: Props) => {
	const { appName, shouldRemoveMargin = false } = props;
	const [{ data: pageContextData, error: pageContextError }] = usePageContext();
	const { projectContext, tenantContext, serviceDeskContext } = pageContextData || {};
	const { projectKey, projectName } = projectContext || {};
	const { locale, activationId } = tenantContext || {};
	const { projectId } = projectContext || {};
	const { portalId } = serviceDeskContext || {};

	// Pagecontext has not loaded
	if (!pageContextData && !pageContextError) {
		return <Spinner />;
	}

	const CustomizedPageStyle =
		ff('jsm-kb-nav-refresh-changes-enabled') && shouldRemoveMargin ? Page : PageStyle;

	return (
		<>
			<ServiceDeskAppBase appName={appName}>
				<ServiceDeskDocumentTitle
					// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
					projectName={projectName}
					section="knowledge"
				/>
				<CreateCategoryModal />
				<BreadcrumbManager>
					<ProjectBreadcrumb
						baseUrl=""
						// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
						projectKey={projectKey}
						// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
						projectName={projectName}
					>
						<CustomizedPageStyle>
							{props.children({
								projectKey,
								projectId,
								portalId,
								locale,
								activationId,
							})}
						</CustomizedPageStyle>
					</ProjectBreadcrumb>
				</BreadcrumbManager>
			</ServiceDeskAppBase>
			<JsdGettingStartedPanelShouldRender />
		</>
	);
};

export default KnowledgeHubAppBase;
